import { Skeleton, csx } from '@vtex/admin-ui'
import React from 'react'

export const SkeletonTitle = () => {
  return (
    <Skeleton
      className={csx({
        display: 'block',
        width: '8rem',
        height: '1.375rem',
        marginTop: '$space-1',
      })}
    />
  )
}
